var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfluncersCardCampaignBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 108,
    viewBox: "0 0 540 108",
    fill: "#F8F6FF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6220_29539)",
    fill: "#F8F6FF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152.846,
    height: 36.5098,
    transform: "translate(373 122.625) rotate(-49.1533)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150.99,
    height: 36.5098,
    transform: "translate(563.309 133.375) rotate(-139.153)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152.846,
    height: 36.5098,
    transform: "translate(244.406 -39.5312) rotate(131.083)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150.99,
    height: 36.5098,
    transform: "translate(54.1445 -51.0664) rotate(41.083)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152.846,
    height: 36.5098,
    transform: "translate(-76 158.301) rotate(-54.4148)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150.99,
    height: 36.5098,
    transform: "translate(114.492 151.555) rotate(-144.415)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152.846,
    height: 36.5098,
    transform: "translate(148.453 171.012) rotate(-62.8683)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150.99,
    height: 36.5098,
    transform: "translate(335.887 136.336) rotate(-152.868)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152.846,
    height: 36.5098,
    transform: "translate(440.891 -47.0781) rotate(129.933)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150.99,
    height: 36.5098,
    transform: "translate(250.434 -54.7891) rotate(39.9333)",
    fill: "#F2EAFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluncersCardCampaignBackground);
export default __webpack_public_path__ + "static/media/influncersCardCampaignBackground.10af910558f10931784b1010d53a9ac3.svg";
export { ForwardRef as ReactComponent };